<template>
  <div id="page-instruction" class="px-3 py-1">
    <v-layout align-center>
      <!-- dynamic page instruction -->
      <p class="body-2 font-weight-bold">
        <fa-icon icon="hand-pointer" fixed-width v-show="text != ''" class="mr-1" /> {{ text }}
      </p>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PageInstruction',
  data() {
    return {
      text: '',
    };
  },
  computed: {
    ...mapGetters('view', ['currentPage']),
  },
  watch: {
    currentPage(newVal) {
      switch (newVal) {
        case 2:
          this.text = 'Hover your mouse over the route to see more details.';
          break;

        case 3:
          this.text = `Click the play button to see how China's GRP change over time.`;
          break;

        case 5:
          this.text = 'Mouse over each country to see more details';
          break;

        case 6:
          this.text = 'Mouse over conflict areas to see more details';
          break;

        case 6.2:
          this.text = 'Mouse over the circles to see more details';
          break;

        case 7:
          this.text = 'Explore the map to know more about projects and infrastructures along the Belt and Road.';
          break;

        default:
          this.text = '';
          break;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
#page-instruction {
  position: absolute;
  z-index: 10;
  left: 50%;
  bottom: 2%;
  transform: translate(-50%, -2%);
  background-color: #F8F4EE;
  text-align: center;

  p {
    margin-bottom: 0;
    line-height: 1.4;
  }
}
</style>
